<template>
	<div>
		<!-- 8047: Disable sticker sparkles for now. -->
		<SparkleBox v-if="false" class="my-5">
			<div class="px-5 py-3 border-radius-6 plan-toggle d-sm-flex align-center justify-space-between">
				<span class="fs--16 fw--600 black--text">
					Enable "Sticker Sparkles" across all channels when you subscribe at any tier!
				</span>
				<div class="d-sm-flex mt-3 mt-sm-0 align-center">
					<v-btn class="px-6" color="purple" depressed @click="sparklesModal = !sparklesModal">
						Learn More
					</v-btn>
				</div>
			</div>
		</SparkleBox>

		<v-row class="subscription-plans">
			<v-col v-for="(plan, index) in plans" :key="index" cols="12" sm="6" md="4" lg="3">
				<FreePlan
					v-if="plan.tier === SubPlan.FREE"
					:subTier="subTier"
					:currentPlan="currentPlan"
					@subscribe="actions.subscribe(plan)" />

				<PremiumPlan
					v-if="plan.tier === SubPlan.PREMIUM"
					:subTier="subTier"
					:currentPlan="currentPlan"
					@subscribe="actions.subscribe(plan)" />
				<PremiumPlusPlan
					v-if="plan.tier === SubPlan.PLUS"
					:subTier="subTier"
					:currentPlan="currentPlan"
					@subscribe="actions.subscribe(plan)" />
				<PremiumExtremePlan
					v-if="plan.tier === SubPlan.EXTREME"
					:subTier="subTier"
					:currentPlan="currentPlan"
					@subscribe="actions.subscribe(plan)" />
			</v-col>
		</v-row>

		<SparklesModal :modal="sparklesModal" @close="sparklesModal = false" />

		<TwitchAffiliateModal
			:modal="affiliateModal"
			:plan="selectedPlan"
			:current="currentPlan"
			@upgrade="actions.upgrade"
			@close="affiliateModal = false" />

		<SubscribeModal
			:modal="subscribeModal"
			:plan="selectedPlan"
			:current="currentPlan"
			@close="subscribeModal = false" />
	</div>
</template>

<script>
import { computed, ref } from '@vue/composition-api';
import store from '@/store';
import FreePlan from './FreePlan.vue';
import PremiumPlan from './PremiumPlan.vue';
import PremiumPlusPlan from './PremiumPlusPlan.vue';
import PremiumExtremePlan from './PremiumExtremePlan.vue';
import SparklesModal from './SparklesModal.vue';
import SubscribeModal from './SubscribeModal.vue';
import { SubPlan, getSubPlanName } from '@/utils/constants.js';
import SparkleBox from '@/components/SparkleBox.vue';
import TwitchAffiliateModal from './TwitchAffiliateModal.vue';
import { getBroadcasterType , getUserId} from '@/utils/auth.js';
import { trackEvent } from '@/utils/mixpanel';

export default {
	components: {
		FreePlan,
		PremiumExtremePlan,
		PremiumPlan,
		PremiumPlusPlan,
		SparklesModal,
		SubscribeModal,
		TwitchAffiliateModal,
		SparkleBox,
	},

	setup() {
		// Current subscription tier and related plan.
		const subTier = computed(() => store.state.app.subTier);
		const currentPlan = computed(() => store.state.app.subPlans.find(plan => plan.tier === subTier.value));

		// Selected plan for subscription via the Subscribe or Upgrade button.
		const selectedPlan = ref(null);

		// Modals.
		const sparklesModal = ref(false);
		const subscribeModal = ref(false);
		const affiliateModal = ref(false);

		const actions = {
			subscribe(plan) {
				selectedPlan.value = { ...plan };

				// If user is a non-affilate, show the warning dialog.
				const broadcasterType = getBroadcasterType();
				if (broadcasterType && broadcasterType.length > 0) {
					subscribeModal.value = true;

					actions.trackSubscribeEvent();

				} else {
					affiliateModal.value = true;
				}
			},
			upgrade(plan) {
				selectedPlan.value = { ...plan };
				affiliateModal.value = false;
				subscribeModal.value = true;

				actions.trackSubscribeEvent();
			},
			trackSubscribeEvent() {
				const planName = getSubPlanName(selectedPlan.value.tier);

				trackEvent({
					type: 'premium_purchase_click',
					params: {
						campaign_name: 'Premium Purchase',
						event_label: 'User Clicked to Subscribe Premium Plan',
						sub_tier: planName,
						user_id: getUserId(),
					},
				});
			}
		};

		return {
			sparklesModal,
			subscribeModal,
			affiliateModal,
			selectedPlan,
			plans: computed(() => store.state.app.subPlans),

			subTier,
			currentPlan,
			SubPlan,

			actions,
		};
	},
};
</script>

<style lang="scss">
.plan-toggle {
	background: red !important;
	border-radius: 6px;

	background: -webkit-linear-gradient(to right, #12fffc 5%, #ffbf12 70%) !important;
	background: -o-gradient(to right, #12fffc 5%, #ffbf12) !important;
	background: -ms-gradient(to right, #12fffc 5%, #ffbf12) !important;
	background: -moz-gradient(to right, #12fffc 5%, #ffbf12) !important;
	background: linear-gradient(to right, #12fffc 5%, #ffbf12 70%) !important;
}

.subscription-plans {
	.plan {
		position: relative;
		transition: all 0.3s ease;

		.plan-footer {
			position: absolute;
			bottom: 10px;
			width: 95%;
			left: 2.5%;
		}
	}
}
</style>
